// extracted by mini-css-extract-plugin
module.exports = {"svg":"Canvas_svg__2w1z4"};